<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <b-card>
        <b-form-group>
          <label>
            <b> {{ $t('table_chosen') }} </b>
          </label>
          <b-form-select v-model="table" :options="table_options" />
        </b-form-group>
      </b-card>

      <b-card :header="$t('columns_listing')">
        <b-list-group>
          <lazy-list-display-y
            :nb="columns.length"
            class="synaplus-cosmo-h-480"
          >
            <template #default="{ nby, height, initialized }">
              <b-list-group-item
                v-if="initialized"
                :key="nby"
                :style="height"
                >{{ columns[nby] }}</b-list-group-item
              ><b-list-group-item v-else :key="nby">&nbsp;</b-list-group-item>
            </template>
          </lazy-list-display-y>
        </b-list-group>
      </b-card>
      <b-card class="mt-3" :header="$t('filter')">
        <b-form-group>
          <togglable-code-editor
            v-model="filter_formula"
            :columns="columns"
            :disabled="changes_disabled"
          />

          <b-form-checkbox
            v-model="use_project_code"
            :value="true"
            :unchecked-value="false"
            >{{ $t('use_project_code') }}
          </b-form-checkbox>
        </b-form-group>
      </b-card>

      <unroll-element :title="$t('code_stdout')" :available="true">
        <unroll-element
          v-for="(metavariables_dict_poid, index) in metavariables_dicts_poids"
          :title="stringified_dict(metavariables_dict_poid)"
          :available="true"
        >
          <pre>{{ metavariables_dicts_code_stdout[index] }}</pre>
        </unroll-element>
      </unroll-element>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "filter": "Filter",
    "code_stdout": "Standard output",
    "use_project_code": "Use project code"
  },
  "fr": {
    "filter": "Filtre",
    "code_stdout": "Sortie standard",
    "use_project_code": "Utiliser le code spécifique au projet"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { BListGroupItem } from 'bootstrap-vue'

import { table_columns } from '@/api/subscriptions.js'

import { global_brick_mixin } from '@/components/mixin.js'
import UnrollElement from '@/components/unroll_element.vue'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'

import { BasicTableInfoEntity } from '@/components/object_model.js'

import TogglableCodeEditor from '@/components/togglable_code_editor.vue'

// *****************************************************************************

export default {
  name: 'BrickFilter',
  components: {
    LazyListDisplayY,
    UnrollElement,
    TogglableCodeEditor,
  },

  mixins: [global_brick_mixin],

  data() {
    return {
      table: -1,
      filter_formula: '',
      columns: [],
      use_project_code: false,
    }
  },
  computed: {
    metavariables_dicts_code_stdout() {
      let res = _.map(
        this.tracking_infos,
        elt => ((elt || {}).code_output || {})['filter'] || ''
      )
      return res
    },
    adapted_data() {
      let entry_table_id = []
      if (this.table !== -1) {
        let parent_info_entity_type = new BasicTableInfoEntity()
        parent_info_entity_type.uid = this.table
        entry_table_id.push(parent_info_entity_type)
      }
      let adapted = {
        uid: this.brick_id,
        parents_info: entry_table_id,
        filter_formula: this.filter_formula,
        use_project_code: this.use_project_code,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        this.filter_formula = new_val.filter_formula
        this.table = (new_val.parents_info[0] || {}).uid || -1
        this.use_project_code = new_val.use_project_code
      },
    },

    table: {
      immediate: true,
      async handler(new_val) {
        this.columns =
          (await table_columns(this.project_id, new_val)).pipe_object || []
        this.filter_formula = this.cur_brick.filter_formula
      },
    },
  },
}
</script>
